/* eslint-disable */
import React, { useContext, useMemo, useState } from "react";

import { FormControl, OutlinedInput } from "@mui/material";
import { Grid, Paper, TextField, Button, Typography } from "@material-ui/core";
import { useHistory, Link, useParams } from "react-router-dom";
import {
  backgroundStyle,
  btnStyle,
  h2Style,
  inputStyle,
  logoStyle,
  paperStyle,
  pStyle,
} from "./styles";
import { AuthContext } from "../../contexts/authContext";
import { Header } from "components/Header/Header";
import { AuthPAGES } from "./pages";

const VerifyPhone: React.FC<any> = () => {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const authFunctionalities = authContext.globalConfig?.authConfig;
  const [genericErrorMessage, setGenericErrorMessage] = useState("");
  const [code, setCode] = useState("");

  const theme = useMemo(() => {
    return authContext.globalConfig?.theme as unknown as undefined;
  }, [authContext]);

  const { phone, email }: any = useParams();

  const onReSendCode = async () => {
    // if (phone) await authContext.onConfirmCodeResendCodePhone(phone, email);
  };

  const sendCode = async (e: any) => {
    e.stopPropagation();
    if ((code && code.length > 0) && code.length <= 6) {
      if (phone) {
        try {
          history.push(AuthPAGES.signIn);
          await authContext.onConfirmCodeSubmittedPhone(code, phone, email);
        } catch (e: any) {
          setGenericErrorMessage(e.message);
        }
      } else
        try {
          await authContext.onConfirmCodeSubmitted(code, email, email);
          history.push(AuthPAGES.signIn);
        } catch (error) {
          console.log(error);
        }
    }
  };

  return (
    <>
      {/* <Header showSettings={false} /> */}
      <div style={backgroundStyle}>
        <Grid container justifyContent="center" alignContent="center">
          <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
            <Paper elevation={0} style={paperStyle}>
              <div style={{ margin: "0px auto" }}>
                <Grid style={logoStyle}>
                  <h2 style={h2Style}>Set up 2 Factor Authentication</h2>
                  <p style={{ ...pStyle, fontSize: "14px" }}>
                    We sent a text message with verification code to provided
                    phone number.
                </p>
                </Grid>
                <FormControl fullWidth variant="outlined">
                  <OutlinedInput
                    error={genericErrorMessage != ""}
                    size="small"
                    style={{ ...inputStyle, marginTop: "0" }}
                    type="text"
                    value={code}
                    onChange={(e: any) => setCode(e.target.value)}
                    placeholder="Enter Code"
                  />
                </FormControl>
              </div>
            </Paper>
            <Button
              type="submit"
              color="primary"
              fullWidth
              variant="contained"
              style={btnStyle}
              onClick={(e) => {
                sendCode(e);
              }}
            >
              Submit
          </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default VerifyPhone;
